export class StatusColors {
	static green = "green";
	static yellow = "yellow";
	static red = "red";
}